class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      let itemsToRemove = [this.dataset.key];
      let lines = [this.dataset.index];
      if (this.dataset.linkedkey) {
        itemsToRemove.push(this.dataset.linkedkey);
        let linked_el = document.querySelector(`[data-key="${this.dataset.linkedkey}"]`);
        lines.push(linked_el.dataset.index);
      }
      this.closest('cart-items').removeItems(lines, itemsToRemove);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.maybeEnableCheckoutButton();
    this.addEventListener('click', e => {
        if(e.target.classList.contains('validate-enrollment-code')) {
            this.validateEnrollmentCode(e);
        }
    });

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    this.removeNotForSale();
  }

  onChange(event) {
    // Updating the enrollment code should not trigger a change
    if(event.target.classList.contains("enrollment-code-input")){
        return;
    }
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        document.getElementById('main-cart-footer')?.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        document.getElementById(`CartItem-${line}`)?.querySelector(`[name="${name}"]`)?.focus();
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  removeItems(lines, keys) {
    lines.forEach(this.enableLoading.bind(this));
    for (let i = 0; i < lines.length; i++) {
      this.enableLoading(lines[i]);
    }

    let body_data = {
      updates: {},
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    };

    keys.forEach(key => { body_data.updates[key] = 0; });

    const body = JSON.stringify(body_data);

    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        document.getElementById('main-cart-footer')?.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        for (let i = 0; i < lines.length; i++) {
          const line = lines[i];
          this.updateLiveRegions(line, parsedState.item_count);
          document.getElementById(`CartItem-${line}`)?.focus();
        }
        this.disableLoading();
        this.maybeEnableCheckoutButton();
      }).catch((e) => {
        console.error(e);
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });

  }

  removeNotForSale() {
    let remove_buttons = Array.from(
        document.querySelectorAll('.cart-item.remove_not_for_sale .cart-item__remove cart-remove-button')
    );
    let lines = remove_buttons.map(e => e.dataset.index);
    let keys = remove_buttons.map(e => e.dataset.key);
    this.removeItems(lines, keys);
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      let error_el = document.getElementById(`Line-item-error-${line}`);
      if (error_el) {
        error_el
          .querySelector('.cart-item__error-text')
          .innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            document.getElementById(`Quantity-${line}`).value
          );
      }
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll('.loading-overlay')[line - 1].classList.remove('hidden');
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }

// If all buttons have been validated, enable the checkout button
  maybeEnableCheckoutButton() {
    let enrollment_validation_buttons = Array.from(document.querySelectorAll('.validate-enrollment-code'));
    if(enrollment_validation_buttons.every(e => e.classList.contains('is-valid'))) {
        document.querySelector('.cart__checkout-button').disabled = false;
        return;
    }
    document.querySelector('.cart__checkout-button').disabled = true;
  }

  validateEnrollmentCode(e) {
    // Prevent form submission
    e.preventDefault();
    // Get both values from DOM
    var code_input_parent = e.target.parentElement;
    var code_input_element = code_input_parent.querySelector('.enrollment-code-input');
    var code_input_button = code_input_parent.querySelector('.validate-enrollment-code');
    var product_sku = code_input_element.dataset.sku;
    var enrollment_code = code_input_element.value.trim();
    var message_element = code_input_parent.querySelector('.message');

    code_input_parent.classList.add('loading');
    code_input_element.setAttribute('disabled', 'disabled');
    code_input_button.setAttribute('disabled', 'disabled');

    const successCallback = this.maybeEnableCheckoutButton.bind(this);

    $.ajax({
        type: "POST",
        contentType: 'application/json',
        url: `${window.api_base_url}/verifyAccessCodes`,
        headers: {"cec-key": "{{ settings.app_key }}"},
        data: JSON.stringify(Object.fromEntries([[product_sku, enrollment_code]]))
    }).done(function(response) {
      if (!response?.success || !response?.enrollment_codes || response.enrollment_codes.length == 0) {
        message_element.style.color = 'red';
        message_element.innerHTML = "Unable to verify code";
      } else {
        if (response.enrollment_codes[product_sku] != undefined && response.enrollment_codes[product_sku] === true) {
          e.target.classList.add('is-valid');
          successCallback();

          // Visual changes
          e.target.style.display = 'none';
          code_input_element.disabled = true;
          message_element.style.color = 'green';
          message_element.innerHTML = "✓";
        } else {
          message_element.style.color = 'red';
          message_element.innerHTML = "Invalid";
        }
      }
      code_input_parent.classList.remove('loading');
      code_input_element.removeAttribute('disabled');
      code_input_button.removeAttribute('disabled');
    });
  }
}

customElements.define('cart-items', CartItems);
